interface ProfileInfoProps {
  profile: {
    name: string;
    age: number;
    genre: string;
    bio: string;
  };
}

export default function ProfileInfo({ profile }: ProfileInfoProps) {
  return (
    <div className="mb-6">
      <h1 className="text-3xl font-bold mb-2 text-gray-50">
        {profile.name}, {profile.age}
      </h1>
      <p className="text-pink-500 mb-4">{profile.genre}</p>
      <p className="text-gray-400">{profile.bio}</p>
    </div>
  );
}
